import dayjs from 'dayjs'
import DateFormat from '../types/enums/DateFormat'

export const calculateTimeDifference = (
  from: string,
  to: string
): { hoursDifference: number; minutesDifference: number } => {
  const fromTime = dayjs(from, DateFormat.HourMinute)
  let toTime = dayjs(to, DateFormat.HourMinute)

  if(toTime.isSame(dayjs('00:00', 'HH:mm'))){
    toTime = toTime.add(1, 'day')
  }
  
  if (fromTime.isAfter(toTime)) {
    return { hoursDifference: 0, minutesDifference: 0 }
  }
  const timeDiffInMinutes = toTime.diff(fromTime, 'minute')

  if (isNaN(timeDiffInMinutes)) {
    return { hoursDifference: 0, minutesDifference: 0 }
  }
  const hours = Math.floor(timeDiffInMinutes / 60)
  const minutes = timeDiffInMinutes % 60

  return { hoursDifference: hours, minutesDifference: minutes }
}
